import React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { AuthContext } from '../../../../authContext/context';
import { useContext, useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../../../lib/axiosIntercepter';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import HelpIcon from '@mui/icons-material/Help';
import Modal from 'react-bootstrap/Modal';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs';

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Template Guide
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Element</th>
                <th>Syntax</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Merge Field</td>
                <td><pre className="m-0"><b>'</b>MergeFieldName<b></b></pre></td>
              </tr>
              <tr>
                <td>Headings</td>
                <td>
                  <pre className="m-0"><b>#</b> Largest heading
<b>##</b> Heading
<b>###</b> Heading
<b>####</b> Heading
<b>#####</b> Heading
<b>######</b> Smallest heading</pre>
                </td>
              </tr>
              <tr>
                <td>Italics</td>
                <td><pre className="m-0"><b>*</b>This text is italicized<b>*</b></pre></td>
              </tr>
              <tr>
                <td>Bold</td>
                <td><pre className="m-0"><b>**</b>This text is bold<b>**</b></pre></td>
              </tr>
              <tr>
                <td>Unordered List</td>
                <td>
                  <pre className="m-0"><b>-</b> List item
<b>-</b> List item
<b>  -</b> Use a two-space indent for nested lists
</pre>
                </td>
              </tr>
              <tr>
                <td>Numbered List</td>
                <td>
                  <pre className="m-0"><b>1.</b> List item
<b>2.</b> List item
<b>  1.</b> Numbered lists can also be nested
</pre>
                  <p className="text-info small m-0 fst-italic">Note: the specific numbers don't actually matter. You could use 1. for each list item and the list will be correctly numbered when rendered</p>
                </td>
              </tr>
              <tr>
                <td>Horizontal Line</td>
                <td>
                  <pre className="m-0"><b>---
***
___</b></pre>
                  <p className="text-info small m-0 fst-italic">Note: Either three hyphens, asterisks or underscores</p>
                </td>
              </tr>
              <tr>
                <td>Hyperlink</td>
                <td>
                  <pre className="m-0">This is an <b>[example link](https://example.com/some-page)</b></pre>
                  <p className="text-info small m-0 fst-italic">Note: You can use merge fields here. For instance, to link a customer to instruct a lead you could use <code>[Click here to Instruct Us](LeadInstructUrl)</code></p>
                </td>
              </tr>
              <tr>
                <td>Image</td>
                <td>
                  <pre className="m-0"><b>![This text shows if image fails to load](https://example.com/image/path.png)</b></pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default function EditBasic() {
  const [loading, setLoading] = useState(false);
  const [loadingTemplate, setLoadingTemplate] = useState(true);
  const [loadingOptions, setLoadingOptions] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();

  // Template form data
  const [templateData, setTemplateData] = useState({
    name: '',
    emailThemeId: '',
    productId: '',
    subject: '',
    content: ''
  });

  // Dropdown options
  const [dropdownOptions, setDropdownOptions] = useState({
    emailThemes: [],
    products: []
  });

  console.log('sadadasd')

  // Fetch dropdown options
  useEffect(() => {
    const fetchDropdownOptions = async () => {
      try {
        const response = await axiosInstance.get('private/email-templates-options');
        const data = response.data;

        if (data.status === 200) {
          setDropdownOptions(data.data);
        } else {
          throw new Error(data.message || 'Failed to fetch dropdown options');
        }
      } catch (error) {
        console.error('Error fetching dropdown options:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load dropdown options'
        });
      } finally {
        setLoadingOptions(false);
      }
    };

    if (authCtx.token) {
      fetchDropdownOptions();
    }
  }, [authCtx.token]);

  // Fetch template data for editing
  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const response = await axiosInstance.get(`private/email-templates/${id}`);
        const data = response.data;

        if (data.status === 200) {
          const template = data.data;
          setTemplateData({
            name: template.name || '',
            emailThemeId: template.emailThemeId?._id || '',
            productId: template.productId?._id || '',
            subject: template.subject || '',
            content: template.content || ''
          });
        } else {
          throw new Error(data.message || 'Failed to fetch template');
        }
      } catch (error) {
        console.error('Error fetching template:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error Loading Template',
          text: error.message || 'Failed to load template data'
        }).then(() => {
          navigate('/emailtemplates');
        });
      } finally {
        setLoadingTemplate(false);
      }
    };

    if (id && authCtx.token) {
      fetchTemplate();
    }
  }, [id, authCtx.token, navigate]);

  // Handle input changes
  const handleInputChange = (field, value) => {
    setTemplateData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!templateData.name || !templateData.emailThemeId || !templateData.productId || 
        !templateData.subject || !templateData.content) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please fill in all required fields'
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axiosInstance.put(`private/email-templates/${id}`, templateData);
      const data = response.data;

      if (data.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Email template updated successfully!'
        }).then(() => {
          navigate('/emailtemplates');
        });
      } else {
        throw new Error(data.message || 'Failed to update template');
      }
    } catch (error) {
      console.error('Update template error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to update email template'
      });
    } finally {
      setLoading(false);
    }
  };

  if (loadingOptions || loadingTemplate) {
    return (
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>Edit Email Template</h1>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Email Templates', path: '/emailtemplates' },
          { label: 'Edit Basic Template', path: '' }
        ]}
      />
      <br />
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>Edit Email Template</h1>
      </div>

      <div className='page-top-formview mb-3'>
        <Form onSubmit={handleSubmit}>
          {/* Template Name and Theme */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="templateName">
                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
                  <TextField 
                    label="Template Name" 
                    variant="outlined" 
                    required
                    value={templateData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    placeholder="e.g., Welcome Email for LSS Grant"
                  />
                </FormControl>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="emailTheme">
                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" required>
                  <InputLabel>Email Theme</InputLabel>
                  <Select
                    value={templateData.emailThemeId}
                    label="Email Theme"
                    onChange={(e) => handleInputChange('emailThemeId', e.target.value)}
                  >
                    <MenuItem value="">
                      <em>Select an Email Theme</em>
                    </MenuItem>
                    {dropdownOptions.emailThemes.map((theme) => (
                      <MenuItem key={theme._id} value={theme._id}>
                        {theme.name} ({theme.type})
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>Choose the email theme to style this template</FormHelperText>
                </FormControl>
              </Form.Group>
            </Col>
          </Row>

          {/* Subject and Product */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="emailSubject">
                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
                  <TextField 
                    label="Email Subject" 
                    variant="outlined" 
                    required
                    value={templateData.subject}
                    onChange={(e) => handleInputChange('subject', e.target.value)}
                    placeholder="e.g., Welcome to LSS Grant Application Process"
                  />
                </FormControl>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="product">
                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" required>
                  <InputLabel>Product</InputLabel>
                  <Select
                    value={templateData.productId}
                    label="Product"
                    onChange={(e) => handleInputChange('productId', e.target.value)}
                  >
                    <MenuItem value="">
                      <em>Select a Product</em>
                    </MenuItem>
                    {dropdownOptions.products.map((product) => (
                      <MenuItem key={product._id} value={product._id}>
                        {product.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>Choose the product this template is for</FormHelperText>
                </FormControl>
              </Form.Group>
            </Col>
          </Row>

          {/* Content */}
          <Row className="mb-3">
            <Form.Group as={Col} controlId="emailContent">
              <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
                <TextareaAutosize
                  aria-label="Body"
                  minRows={8}
                  placeholder="Write your email content here... You can use placeholders like {customer_name}, {product_name}, etc."
                  style={{ 
                    width: '100%', 
                    padding: '12px', 
                    border: '1px solid #ccc', 
                    borderRadius: '4px',
                    fontFamily: 'inherit',
                    fontSize: '16px',
                    resize: 'vertical'
                  }}
                  value={templateData.content}
                  onChange={(e) => handleInputChange('content', e.target.value)}
                  required
                />
              </FormControl>
              <FormHelperText className='custom-helper-css red-link-text' onClick={() => setModalShow(true)}>
                <HelpIcon/> View Template Guide
              </FormHelperText>
            </Form.Group>
          </Row>

          {/* Submit Button */}
          <Row>
            <MyVerticallyCenteredModal
              show={modalShow}
              onHide={() => setModalShow(false)}
            />
            <Form.Group as={Col} controlId="submitButton">
              <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
                <Stack spacing={2} direction="row">
                  <Button 
                    variant="contained" 
                    type="submit" 
                    disabled={loading}
                    className='red-bg red-button text-capitalize h-56'
                  >
                    {loading ? 'Updating...' : 'Update Template'}
                  </Button>
                  <Button 
                    variant="outlined" 
                    onClick={() => navigate('/emailtemplates')}
                    className='text-capitalize h-56'
                    style={{ borderColor: '#dc2626', color: '#dc2626' }}
                  >
                    Cancel
                  </Button>
                </Stack>
              </FormControl>
            </Form.Group>
          </Row>
        </Form> 
      </div>
    </>
  );
}